import React from "react";
import PropTypes from "prop-types";

import "../style.scss";
/**
 * Title :
 * - Display HexgonNode Title
 */
export function Title(props) {
  const fittedTitle = props.title.slice(0, 20) + "...";
  const className =
    props.type === "OUTPUT_CARD"
      ? "hex_content_output_title"
      : "hex_content_title";
  const renderOverflowTitle = (
    <span data-tooltip={props.title} className={className}>
      {fittedTitle}
    </span>
  );
  const renderNormalTitle = <span className={className}>{props.title}</span>;

  const renderTitle =
    props.title.length > 22 ? renderOverflowTitle : renderNormalTitle;

  return renderTitle;
}

Title.propTypes = {
  /**
   * title
   */
  title: PropTypes.string,
  /**
   * Type of hexagon card
   */
  type: PropTypes.string,
};

Title.defaultProps = {
  title: "",
  type: "",
};
